// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MUu5","title":"styles_title__1bfq1"};